// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".case-new{position:relative;height:400px}.vjsf-property-tickets .disabled{position:relative;pointer-events:none;opacity:.5}", ""]);
// Exports
module.exports = exports;
